import type {
  WeeklyPresetId,
  WeeklyComparisonPresetId,
  MonthlyPresetId,
  MonthlyComparisonPresetId,
} from 'components/filter/input/DateRangePicker/presets';

// ── Weekly ────────────────────────────────────────────────────────────────────

export const BENCHMARKING_WEEKLY_PRESET_IDS: WeeklyPresetId[] = [
  'custom',
  'last_week',
  'last_4_weeks',
  'last_12_weeks',
];

export const BENCHMARKING_WEEKLY_COMPARISON_PRESET_IDS: WeeklyComparisonPresetId[] = [
  'custom',
  'previous_period',
  'previous_year',
];

// ── Monthly ───────────────────────────────────────────────────────────────────

export const BENCHMARKING_MONTHLY_PRESET_IDS: MonthlyPresetId[] = [
  'custom',
  'last_month',
  'last_3_months',
  'last_6_months',
  'last_12_months',
];

export const BENCHMARKING_MONTHLY_COMPARISON_PRESET_IDS: MonthlyComparisonPresetId[] = [
  'custom',
  'previous_period',
  'previous_year',
];
